/**
 * Shared filmic grade + fog for custom particle-lab shaders.
 * Matches THREE.ACESFilmicToneMapping's fitted curve so MeshStandard
 * boxes (renderer ACES) and hand-written shaders land in the same look.
 */
export const GRADE_GLSL = /* glsl */ `
#ifndef PL_GRADE
#define PL_GRADE
vec3 plAces(vec3 x) {
  const float a = 2.51;
  const float b = 0.03;
  const float c = 2.43;
  const float d = 0.59;
  const float e = 0.14;
  return clamp((x * (a * x + b)) / (x * (c * x + d) + e), 0.0, 1.0);
}
const vec3 PL_FOG_COLOR = vec3(0.035, 0.038, 0.048);
const float PL_FOG_NEAR = 24.0;
const float PL_FOG_FAR = 54.0;
const float PL_EXPOSURE = 1.08;
vec3 plGrade(vec3 lin) {
  return plAces(lin * PL_EXPOSURE);
}
vec3 plFog(vec3 col, vec3 worldPos) {
  float f = smoothstep(PL_FOG_NEAR, PL_FOG_FAR, length(worldPos - cameraPosition));
  return mix(col, PL_FOG_COLOR, f);
}
#endif
`;
